module.exports = __webpack_public_path__ + "img/icon-home.83322525.svg";